var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    [`
      bg-gray-900
      bg-opacity-50
      bottom-0
      fixed
      h-full
      left-0
      overflow-auto
      right-0
      scrolling-touch
      top-0
      w-full
      z-40
    `]: _vm.isFullPage,
  }},[_c('div',{staticClass:"flex items-center justify-center",class:{ 'h-full w-full': _vm.isFullPage }},_vm._l((4),function(_,index){return _c('div',{key:`loading-dot-${index}`,staticClass:"loading__dot relative",class:`bg-${_vm.color}`})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }